// Factory function pattern to avoid Webpack TDZ issues with class inheritance
// This uses BaseAdminFactory instead of class inheritance

import { createBaseAdmin, type IBaseAdmin } from "../BaseAdminFactory";
import type {
	IGetClientPortalSessionResponse,
	IGetCustomerBySubscriptionIdParams,
	IGetInvoiceByUidResponse,
	IGetPaymentIntentByUidResponse,
	IGetStripeSubscriptionByUidResponse,
	IPostStripeParams,
	IPostStripeResponse,
} from "./Stripe";
import {
	createPostMethod,
	createGetStripeSubscriptionByUidMethod,
	createGetClientPortalSessionMethod,
	createGetCustomerBySubscriptionIdMethod,
	createGetInvoiceByUidMethod,
	createGetPaymentIntentByUidMethod,
	createPostReconcileOfficeMethod,
} from "./helpers/stripeMethodsHelpers";

interface StripeInstance {
	post(body: IPostStripeParams): Promise<IPostStripeResponse>;
	getStripeSubscriptionByUid(stripe_subscription_id: string): Promise<IGetStripeSubscriptionByUidResponse>;
	getClientPortalSession(stripe_subscription_id: string): Promise<IGetClientPortalSessionResponse>;
	getCustomerBySubscriptionId(subscriptionId: string): Promise<IGetCustomerBySubscriptionIdParams>;
	getInvoiceByUid(invoiceId: string): Promise<IGetInvoiceByUidResponse>;
	getPaymentIntentByUid(paymentIntentId: string): Promise<IGetPaymentIntentByUidResponse>;
	reconcileOffice(): Promise<{ reconciled: boolean; officeUid: string }>;
}

// Module-level singleton instance
let instance: StripeInstance | null = null;
let baseAdminInstance: IBaseAdmin | null = null;

function createStripe(): StripeInstance {
	if (!baseAdminInstance) {
		baseAdminInstance = createBaseAdmin();
	}

	const baseAdmin = baseAdminInstance;
	const baseUrl = baseAdmin.namespaceUrl.concat("/stripe");

	return {
		post: createPostMethod(baseAdmin, baseUrl),
		getStripeSubscriptionByUid: createGetStripeSubscriptionByUidMethod(baseAdmin, baseUrl),
		getClientPortalSession: createGetClientPortalSessionMethod(baseAdmin, baseUrl),
		getCustomerBySubscriptionId: createGetCustomerBySubscriptionIdMethod(baseAdmin, baseUrl),
		getInvoiceByUid: createGetInvoiceByUidMethod(baseAdmin, baseUrl),
		getPaymentIntentByUid: createGetPaymentIntentByUidMethod(baseAdmin, baseUrl),
		reconcileOffice: createPostReconcileOfficeMethod(baseAdmin),
	};
}

export function getStripeInstance(): StripeInstance {
	if (!instance) {
		instance = createStripe();
	}
	return instance;
}
